import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 1350;

export function useResponsive() {
  const [isMobile, setIsMobile] = useState(() => {
    // Initialize with correct value on first render
    // Use mobile layout for narrow viewports to prevent text cutoff
    return typeof window !== 'undefined' ? window.innerWidth <= MOBILE_BREAKPOINT : false;
  });

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  return isMobile;
}
